import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
// mui
import { Box, Button, Container } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
// component
import BottomFix from '@/component/common/bottom-fix';
import TopBackButton from '@/component/common/top-back-button';
// lib
import { ShortenAddr, ShortenTxId } from '@/lib/Shorten';
import { weiToEther } from '@/lib/ether/parseValue';
import { copy } from '@/lib/util';
import theme from '@/theme';

export default function TxHistory() {
  const {
    state: { data, symbol, address },
  } = useLocation();
  const { t } = useTranslation();
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '653px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="상세"
        boxProps={{
          mb: 4,
        }}
        backPath={'/walletDetail'}
        backPathOption={{
          symbol: symbol,
        }}
      />
      <Box mb={7} />
      <Grid container spacing={2}>
        <Grid xs={4} sx={{ textAlign: 'left' }}>
          상태
        </Grid>
        <Grid xs sx={{ textAlign: 'right' }}>
          {data.from.toLowerCase() === String(address).toLowerCase() ? '보내기' : '받기'}
        </Grid>
      </Grid>
      <Box mb={3} />
      <Grid container spacing={2}>
        <Grid xs={4} sx={{ textAlign: 'left' }}>
          {data.from.toLowerCase() === String(address).toLowerCase() ? 'To' : 'From'}
        </Grid>
        <Grid xs sx={{ textAlign: 'right' }}>
          {data.from.toLowerCase() === String(address).toLowerCase() ? ShortenAddr(data.to) : ShortenAddr(data.from)}
        </Grid>
      </Grid>
      <Box mb={3} />
      <Grid container spacing={2}>
        <Grid xs={4} sx={{ textAlign: 'left' }}>
          txHash
        </Grid>
        <Grid xs sx={{ textAlign: 'right' }}>
          <Grid xs>
            <Button
              onClick={() => {
                const url =
                  process.env.NODE_ENV === 'production'
                    ? `https://polygonscan.com/tx/${data.hash}`
                    : `https://amoy.polygonscan.com/tx/${data.hash}`;
                window.open(url);
                copy(String(url));
                toast.success(`${t('toast.copyTransactionHash')}`);
              }}
              sx={{ color: 'black', textTransform: 'none', textAlign: 'right' }}
            >
              {ShortenTxId(data.hash)}
              <br />
              (복사)
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Box mb={3} />
      <Grid container spacing={2}>
        <Grid sx={{ textAlign: 'left' }}>전송 수량</Grid>
        <Grid xs sx={{ textAlign: 'right', color: theme.palette.primary.main, fontWeight: 'bold' }}>
          {data.value} {symbol}
        </Grid>
      </Grid>
      <Box mb={3} />
      <Grid container spacing={2}>
        <Grid xs={4} sx={{ textAlign: 'left' }}>
          시간
        </Grid>
        <Grid xs sx={{ textAlign: 'right' }}>
          <Grid xs>{data.timeStamp}</Grid>
        </Grid>
      </Grid>
      <BottomFix>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            const url =
              process.env.NODE_ENV === 'production'
                ? `https://polygonscan.com/tx/${data.hash}`
                : `https://amoy.polygonscan.com/tx/${data.hash}`;
            window.open(url);
          }}
        >
          Scan 바로가기
        </Button>
      </BottomFix>
      {/* <Box position="absolute" bottom={10} left={0} width="100%" padding={3}></Box> */}
    </Container>
  );
}
